import { render, staticRenderFns } from "./AdditionalFees.vue?vue&type=template&id=139f8b86&scoped=true"
import script from "./AdditionalFees.vue?vue&type=script&lang=ts"
export * from "./AdditionalFees.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalFees.vue?vue&type=style&index=0&id=139f8b86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f8b86",
  null
  
)

export default component.exports